import { ActivatedRouteSnapshot } from '@angular/router';
import {Injectable} from '@angular/core';
import {DipRegistrationInitializerService} from '../core/services/dip-registration-initializer.service';
import {DipRegistrationContextService} from '../core/services/dip-registration-context.service';
import {DipRegistrationErrorsHandler} from '../dip-registration-error/dip-registration-errors.handler';
import {DipRegistrationService} from '../dip-registration.service';
import {DipRegistrationConfirmService} from '../core/services/dip-registration-confirm.service';
import {DipRegistrationLoggerService} from '../core/services/logger/dip-registration-logger.service';

@Injectable()
export class DipRegistrationOverviewResolver  {

  constructor(private dipRegistrationInitializerService: DipRegistrationInitializerService,
              private readonly dipRegistrationContextService: DipRegistrationContextService,
              private readonly dipRegistrationService: DipRegistrationService,
              private readonly logger: DipRegistrationLoggerService,
              private readonly dipRegistrationConfirmService: DipRegistrationConfirmService,
              private readonly errorHandler: DipRegistrationErrorsHandler) {
  }

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    if (this.dipRegistrationContextService.isForceReset()) {
      try {
        await this.dipRegistrationService.resetAndReload();
      } catch (error) {
        await this.errorHandler.handleError(error);
      }
    }
  }
}
